// extracted by mini-css-extract-plugin
export default {"pill":"KPIsPill_pill__9CZx2","selected_pill":"KPIsPill_selected_pill__p7HS8","pill_label":"KPIsPill_pill_label__85Og3"};